import {
  Box,
  Button,
  ButtonNew,
  IconNew as Icon,
  IconNew,
  Spacer,
  SpacerNew,
  Text,
  TextInput,
  TextNew
} from '@jfs/ui-new'
import { useIsFocused } from '@react-navigation/native'
import { observer } from 'mobx-react'
import { FC, useEffect, useState } from 'react'
import { otherFilters } from '../../data/models/Filters'
import { dateRangeData, downloadReportTypeData, exportData, vaultTabData } from '../../data/static/data'
import { actionMenuStrings } from '../../data/static/strings'
import { useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { PaginationController } from '../../screens/PaymentLinks/PaginationController/PaginationController'
import { DateTabs } from '../../screens/Subscriptions/DateTabs'
import { ActionsMenuProps, TransactionsType } from '../../screens/TransactionNew/types'
import { getYesterday, useWindowDimensions } from '../../util/util'
import { DateSelector } from '../DateSelection'
import { DropdownOptimised } from '../DropdownNew'
import { DropdownTypes } from '../DropdownNew/types'
import FieldSettings from '../FieldSettings/FieldSettings'
import FieldSettingsFilterMenu from '../FieldSettings/FieldSettingsFilter'
import Filters from '../FiltersView/Filters'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import { PageSelector } from '../PageSelectorNew'
import { SearchFilter } from '../SearchFilter'
import Tabbar, { TabbarType } from '../Tabbar'
import { styles } from './styles'

const getDateValue = (mValue: number): Date => {
  const today = new Date(Date.now())
  const pastDay = new Date(today.setDate(today.getDate() - mValue))
  pastDay.setMinutes(pastDay.getMinutes() + 1)
  return pastDay
}

const getTodayValue = (): Date => {
  const today = new Date(Date.now())
  return new Date(today.setHours(0, 0, 0, 0))
}

export interface DateType {
  fromDate: Date
  toDate?: Date
  position?: { left: number; top: number; visible: boolean }
}

const getSelectedValue = {
  [actionMenuStrings.lastSeven]: 7,
  [actionMenuStrings.customDate]: 0,
  [actionMenuStrings.lastFifteen]: 15,
  [actionMenuStrings.lastThirty]: 30,
  [actionMenuStrings.lastNinty]: 90,
  [actionMenuStrings.allTime]: 180,
  [actionMenuStrings.yesterday]: 1,
}

const getSelectedDate = (value: string): Date => {
  if (value === actionMenuStrings.today) {
    return getTodayValue()
  } else {
    const days = getSelectedValue[value]
    return getDateValue(days)
  }
}

export const getDropdowntype = () => {
  const calendarModalType = DropdownTypes.DEFAULT_WITH_IMAGE
  const exportModalType = DropdownTypes.RADIO_BUTTON
  const downloadReportModalType = DropdownTypes.DEFAULT_DOWNLOAD_REPORT
  return { calendarModalType, exportModalType, downloadReportModalType }
}

const ActionsMenu: FC<ActionsMenuProps> = ({
  path,
  screenName,
  enableRefundsAction,
  generateSettlementFile,
  handleExport,
  fetchDetailOfPath,
  fieldSettingVisible,
  setFieldSettingVisible,
  filterVisible,
  setFilterVisible,
  fetchTxnColumns,
  generateFileHandler,
  hideFieldSettings = false,
  fetchDetailsOnFiltersClick,
  onSearchTextChange,
  handleCampaignSearch,
  onDownloadRefreshList,
  selectedDateInfo,
  updateSelectedDate,
  defaultMaxDate,
  onReportTemplatesPress,
  hideExportButton = false,
  maxRange,
  scrollToCurrentDate,
  refundTabIndex,
  setRefundTabIndex,
  refundTabBarData,
  showExportOnRight = false,
  hideDateSelector = false,
  handleTokenizationSearch,
  selectedTabIndex = 0,
  setSelectedTabIndex,
  showCalendarOnRight = false,
  showFieldSettingsAndFilters = false,
  handleRefundsSearchBy,
  apiHandler,
}: ActionsMenuProps) => {
  const {
    //date,
    // setNewDate,
    paginationData,
    updatePagination,
    resetPagination,
    //visible,
    // top,
    // left,
    //dateValue,
    // setDateValue,
    // position,
    subscriptionFiltersCount,
    isDateFilterSelected,
    updateOtherFilters,
    clearSubscriptionFilters,
    isFiltersApplied,
    isTransactionFilterApplied,
    returnTransactionFilterCount,
    returnPaymentLinkFilterCount,
    paymentLinkFilterApplied,
    setDownloadReportType,
    downloadReportType,
    canGenerateSettlementReport,
    canCreateCampaigns,
    setMessage,
    isVaultTxnsTabEnabled,
    returnBeneficiaryFilterCount,
  } = useStores((root) => ({
    //date: root.settings.metaData.selectedDate,
    //position: root.settings.metaData.selectedDate.position,
    //visible: root.settings.metaData.selectedDate.position.visible,
    //top: root.settings.metaData.selectedDate.position.top,
    //left: root.settings.metaData.selectedDate.position.left,
    // setNewDate: root.settings.metaData.updateDates,
    paginationData: root?.[path]?.pagination,
    updatePagination: root?.[path]?.updatePagination,
    resetPagination: root?.[path]?.resetPagination ?? (() => { }),
    // dateValue: root.settings.metaData.dateValue,
    //setDateValue: root.settings.metaData.setDateValue,
    subscriptionFiltersCount: root.transactions.filter.getSubscriptionFilterCount(),
    isDateFilterSelected: root.transactions.filter.isDateFilterSelected(),
    updateOtherFilters: root.transactions.filter.updateOtherFilters,
    clearSubscriptionFilters: root.transactions.filter.clearSubscriptionFilters,
    isFiltersApplied: root.transactions.filter.isFiltersApplied,
    isTransactionFilterApplied: root.transactions.filter.isTransactionFilterApplied,
    returnTransactionFilterCount: root.transactions.filter.returnTransactionFilterCount(),
    returnPaymentLinkFilterCount: root.links.returnPaymentLinkFilterCount().count,
    paymentLinkFilterApplied: root.links.returnPaymentLinkFilterCount().isApplied,
    setDownloadReportType: root.settings.metaData.setDownloadReportType,
    downloadReportType: root.settings.metaData.downloadReportType,
    canGenerateSettlementReport: root.userManagement.canGenerateSettlementReport(),
    canCreateCampaigns: root.userManagement.canCreateCampaigns(),
    setMessage: root.response?.setMessage,
    isVaultTxnsTabEnabled: root.userManagement.canViewVaultTransactions(),
    returnBeneficiaryFilterCount: root.transactions.filter.returnBeneficiaryFilterCount,
  }))

  const handlePagination = (selectedPage: number) => {
    updatePagination(selectedPage)
    if (fetchDetailOfPath) {
      fetchDetailOfPath()
    }
  }
  const isFocused = useIsFocused()

  const window = useWindowDimensions()

  useEffect(() => {
    /*
    resetting the date on path change
    */
    //Fix for BulkRefund list Api was calling twice
    if (path !== Routes.BULK_REFUND && path !== Routes.CAMPAIGNS && path !== Routes.DOWNLOADS) {
      resetPagination()
      //setDateValue(actionMenuStrings.today)
      // const today = new Date(Date.now())
      /*  setNewDate({
        fromDate: new Date(today.setHours(0, 0, 0, 0)),
        toDate: new Date(),
        position: { ...position, visible: false },
      })*/

      //TODO: Uncomment this out if you want to reset the pagination on each tab change and dont want to persist the date data.
      //  updateSelectedDate(
      //         {
      //           dateLabel: actionMenuStrings.today,
      //           fromDate: new Date(today.setHours(0, 0, 0, 0)),
      //           toDate: new Date(),
      //           position: { ...selectedDateInfo.position, visible: false },
      //         },
      //       )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path])

  const isMobile = window?.width < 560
  const [fileType, setFileType] = useState(actionMenuStrings.excel)

  const onDateSelected = (dateObj: DateType): void => {
    resetPagination()
    /*     setDateValue(actionMenuStrings.customDate)
    setNewDate({
      fromDate: dateObj.fromDate,
      toDate: dateObj.toDate,
      position: { ...dateObj.position, visible: false },
    }) */
    updateSelectedDate({
      dateLabel: actionMenuStrings.customDate,
      fromDate: dateObj.fromDate,
      toDate: dateObj.toDate,
      position: { ...dateObj.position, visible: false },
    })
    if (fetchDetailOfPath) {
      fetchDetailOfPath()
    }
  }

  const handleOnChange = (value: string | number[]): void => {
    setFileType(typeof value === 'string' ? value : fileType)
  }

  const onAction = (fType: string) => {
    if (path === Routes.SETTLEMENTS && generateSettlementFile) {
      generateSettlementFile(fType)
    } else {
      if (handleExport) {
        handleExport(fType, path, selectedDateInfo)
      }
    }
  }

  const onDateRangeSelected = (value: string | number[], pos: any): void => {
    path !== Routes.CAMPAIGNS && resetPagination()
    const dateStr = value.toString()
    /* if (dateStr !== 'Custom Range') {
      setDateValue(dateStr)
    } */
    const today = new Date(Date.now())
    let currentDay = dateStr === actionMenuStrings.customDate ? selectedDateInfo.toDate : today
    let finishDay =
      dateStr === actionMenuStrings.customDate ? selectedDateInfo?.fromDate : getSelectedDate(value.toString())
    if (dateStr === actionMenuStrings.yesterday) {
      finishDay = getYesterday('START')
      currentDay = getYesterday('END')
    }
    /* setNewDate({
      fromDate: finishDay,
      toDate: currentDay,
      position: { ...pos, visible: dateStr === actionMenuStrings.customDate },
    }) */
    updateSelectedDate({
      dateLabel: dateStr !== 'Custom Range' ? dateStr : selectedDateInfo.dateLabel,
      fromDate: finishDay,
      toDate: currentDay,
      position: { ...pos, visible: dateStr === actionMenuStrings.customDate },
    })
    if (dateStr !== actionMenuStrings.customDate && fetchDetailOfPath) {
      fetchDetailOfPath()
    }
  }

  const onDownloadReportTypeSelected = (value: any, pos: any): void => {
    console.log('value pos', value, pos)
    setDownloadReportType(value)
  }

  const navigateTo = () => {
    // check: Removed navigation inside comps
    // navigate(Routes.INITIATEREFUNDS)
  }

  const dropDownType = getDropdowntype()

  const applyFilters = () => {
    resetPagination()
    if (fetchDetailsOnFiltersClick) {
      fetchDetailsOnFiltersClick()
    }
    if (fetchDetailOfPath) {
      fetchDetailOfPath()
    }
  }

  const fetchTxnColumnsData = () => {
    if (fetchTxnColumns) {
      fetchTxnColumns()
    }
  }
  const handleGenerate = () => {
    if (generateSettlementFile) {
      generateSettlementFile('') //Passing empty as filetype based on which we are changing requestbody in api
    }
  }

  const onDateTabs = (fromDate: Date, toDate: Date, dateLabel: string) => {
    resetPagination()
    /*  setNewDate({
      fromDate: fromDate,
      toDate: toDate,
    })
 */ updateSelectedDate({
      ...selectedDateInfo,
      fromDate,
      toDate,
      dateLabel,
    })
    updateOtherFilters('createdAt', otherFilters.subscriptionDateType)
    if (fetchDetailOfPath) {
      fetchDetailOfPath()
    }
  }

  const clearFilters = () => {
    clearSubscriptionFilters()
    if (fetchDetailOfPath) {
      fetchDetailOfPath()
    }
  }

  // const onReportTemplatedPress = () => {
  //   navigateTo(Routes.SETTLEMENTS_REPORTING)
  // }

  const dataExport = exportData()

  const renderDateSelector = () => {
    return (
      <Box {...styles.dateSelectorContainer} mt={path === Routes.VAULT_TOKENIZATION ? 0 : 20}>
        <ModBox show={path === Routes.DOWNLOADS} flexDirection={'row'}>
          {downloadReportType !== '' && (
            <ModBox {...styles.tabsCenter}>
              <IconNew size={'SMALL'} id={'BILL'} />
              <SpacerNew direction="horizontal" size={8} />
              <TextNew type={'link12'} color={'BLACK_21'}>
                {'Report Type'}
              </TextNew>
            </ModBox>
          )}
          <DropdownOptimised
            title={downloadReportType}
            onChange={onDownloadReportTypeSelected}
            data={downloadReportTypeData}
            type={dropDownType.downloadReportModalType as DropdownTypes}
          />
          <Box
            underlayColor={'TRANSPARENT'}
            height={36}
            marginLeft={16}
            onPress={onDownloadRefreshList}
            testID="refresh-downloads">
            <ModBox {...styles.refreshButton}>
              <IconNew size={'SMALL'} id={'ICON_REFRESH'} />
              <SpacerNew direction="horizontal" size={8} />
              <TextNew type={'body12'} color={'BLACK_21'} selectable={false}>
                {'Refresh'}
              </TextNew>
            </ModBox>
          </Box>
        </ModBox>
        <ModBox flexDirection={'row'} show={screenName === 'Refunds' && refundTabBarData?.length > 0}>
          <ModBox show={refundTabIndex === 0}>
            <SearchFilter onSearchPress={handleRefundsSearchBy} label={'Search by refund id'} />
          </ModBox>
          <Tabbar
            default={refundTabIndex}
            titles={refundTabBarData}
            onSelected={setRefundTabIndex}
            type={TabbarType.recentPayments}
          />
          <Spacer direction={'horizontal'} size={16} />
        </ModBox>
        <ModBox
          show={path === 'bulkRefund'}
          underlayColor={'TRANSPARENT'}
          height={36}
          marginHorizontal={16}
          testID="onDownloadRefreshList"
          onPress={onDownloadRefreshList}>
          <ModBox {...styles.refreshButton}>
            <IconNew size={'SMALL'} id={'ICON_REFRESH'} />
            <SpacerNew direction="horizontal" size={8} />
            <TextNew type={'body12'} color={'BLACK_21'} selectable={false}>
              {'Refresh'}
            </TextNew>
          </ModBox>
        </ModBox>
        <ModBox
          show={
            path !== TransactionsType.subscriptions &&
            path !== Routes.DOWNLOADS &&
            path !== Routes.SETTLEMENTS_REPORTING &&
            !hideDateSelector
          }
          {...styles.mobileSelectionFix}>
          <DropdownOptimised
            placeHolder={selectedDateInfo?.dateLabel}
            iconType="CALENDAR"
            onChange={onDateRangeSelected}
            data={dateRangeData}
            type={dropDownType.calendarModalType as DropdownTypes}
            testID={'calendar'}
          />
          <DateSelector
            path={path}
            screenName={screenName}
            value={{
              fromDate: selectedDateInfo?.fromDate,
              toDate: selectedDateInfo?.toDate,
              position: {
                visible: selectedDateInfo?.position?.visible,
                top: selectedDateInfo?.position?.top,
                left:
                  path === Routes.BULK_REFUND
                    ? selectedDateInfo?.position?.left - 300
                    : selectedDateInfo?.position?.left,
              },
            }}
            isFocused={isFocused}
            onDateSelected={onDateSelected}
            setNewDate={(dateObj: any) =>
              updateSelectedDate({
                dateLabel: actionMenuStrings.customDate,
                fromDate: dateObj.fromDate,
                toDate: dateObj.toDate,
                position: { ...dateObj.position },
              })
            }
            defaultMaxDate={defaultMaxDate}
            maxDuration={maxRange}
            scrollToCurrentDate={scrollToCurrentDate}
            sendError={(err: string) => setMessage(err)}
          />
          <Spacer
            size={16}
            direction="horizontal"
            hide={!(path === TransactionsType.settlements || path === TransactionsType.bulkrefund)}
          />
        </ModBox>
        <ModBox show={path === TransactionsType.subscriptions}>
          <DateTabs
            onDateSelector={onDateTabs}
            disabled={isDateFilterSelected}
            maxRange={maxRange}
            sendError={setMessage}
          />
        </ModBox>
        {path === Routes.BULK_REFUND && (
          <Box {...styles.borderStyle} flexDirection={'row'} alignItems="center">
            <TextInput
              type="body"
              showBottomLine={false}
              fontSize={12}
              fontFamily="jioType-medium"
              placeholder={'Search By Filename…'}
              placeholderTextColor="BLACK_21"
              leftComponent={<Icon id="SEARCH" size={16} color="LIGHT_BLACK" />}
              onChangeText={onSearchTextChange}
            />
          </Box>
        )}
        <ModBox show={canGenerateSettlementReport} mt={1}>
          <ButtonNew
            testID="genSettlementReport"
            onPress={handleGenerate}
            disabled={generateFileHandler?.state === 'pending'}
            type={'custom'}
            borderRadius={4}
            height={35}
            paddingHorizontal={10}
            textType="body12"
            hide={isMobile || path !== TransactionsType.settlements}
            title={actionMenuStrings.labelGenerate}
          />
        </ModBox>
        <Spacer
          size={16}
          direction="horizontal"
          hide={!(path !== TransactionsType.settlements) || isMobile || hideDateSelector}
        />
        <ModBox mt={1} show={!showExportOnRight}>
          <DropdownOptimised
            testID="exportDropDown"
            placeHolder={actionMenuStrings.export}
            onChange={handleOnChange}
            data={dataExport}
            onButtonPress={onAction}
            type={dropDownType.exportModalType}
            hide={
              isMobile ||
              !(path !== TransactionsType.settlements) ||
              path === TransactionsType.paymentlinks ||
              path === TransactionsType.subscriptions ||
              path === TransactionsType.bulkrefund ||
              path === 'campaigns' ||
              path === 'reports' ||
              path === Routes.SETTLEMENTS_REPORTING ||
              hideExportButton ||
              hideDateSelector
            }
          />
        </ModBox>
        <Spacer
          size={16}
          direction="horizontal"
          hide={(path !== Routes.BULK_REFUND && path !== Routes.VAULT_TOKENIZATION) || isMobile || hideDateSelector}
        />
      </Box>
    )
  }
  return (
    <>
      <Box {...styles.topBar}>
        <ModBox flexDirection={'row'} show={path === Routes.PAYOUTS_BENEFICIARY}>
          <Box h={36} mt={20}>
            <Tabbar
              default={selectedTabIndex}
              titles={[{ title: 'All' }, { title: 'Bulk' }]}
              onSelected={setSelectedTabIndex}
              type={TabbarType.recentPayments}
              disabled={apiHandler && apiHandler?.state === 'pending'}
            />
          </Box>
          <Spacer size={16} direction="horizontal" />
          {selectedTabIndex === 1 && renderDateSelector()}
        </ModBox>
        <ModBox flexDirection={'row'} show={path === Routes.VAULT_TOKENIZATION}>
          <Box h={36} mt={20}>
            <Tabbar
              default={selectedTabIndex}
              titles={vaultTabData(isVaultTxnsTabEnabled)}
              onSelected={setSelectedTabIndex}
              type={TabbarType.recentPayments}
            />
          </Box>
          {selectedTabIndex === 0 && <Spacer direction={'horizontal'} size={16} />}
          {selectedTabIndex === 0 && (
            <Box mt={20}>
              <SearchFilter onSearchPress={handleTokenizationSearch} label={'Search by Customer ID..'} />
            </Box>
          )}
        </ModBox>
        {!showCalendarOnRight && path !== Routes.PAYOUTS_BENEFICIARY && renderDateSelector()}
        <Box {...styles.rowContainer}>
          {showCalendarOnRight && path !== Routes.PAYOUTS_BENEFICIARY && renderDateSelector()}
          <ModBox show={canGenerateSettlementReport} {...styles.generateContainer}>
            <Button
              onPress={handleGenerate}
              testID="generateSettlementFile"
              disabled={generateFileHandler?.state === 'pending'}
              type={'SecondaryWithBg'}
              hide={!isMobile || path !== TransactionsType.settlements}
              title={actionMenuStrings.labelGenerate}
            />
          </ModBox>
          <DropdownOptimised
            placeHolder={actionMenuStrings.export}
            onChange={handleOnChange}
            data={dataExport}
            onButtonPress={onAction}
            type={dropDownType.exportModalType}
            testID={'export'}
            hide={!isMobile || !(path !== TransactionsType.settlements)}
          />
          <Spacer size={10} direction="horizontal" />
          <PageSelector
            hide={true}
            totalRecords={paginationData?.totalElements}
            default={paginationData?.number}
            recordsPerPage={paginationData?.size}
            totalPages={paginationData?.totalPages}
            onSelect={handlePagination}
          />
          <ModBox
            {...styles.reportTemplatesButton}
            show={path === 'settlements'}
            testID="reportConfiguration"
            onPress={onReportTemplatesPress}>
            <Text fontFamily="jiotype-medium" color="WHITE" fontSize={12}>
              {'Report Configuration'}
            </Text>
          </ModBox>
          <PaginationController
            hide={path === 'campaigns'}
            currentPage={paginationData?.number ?? 0}
            totalPages={paginationData?.totalPages ?? 0}
            totalDataLength={paginationData?.totalElements ?? 0}
            dataSetSize={paginationData?.size ?? 0}
            onSelect={handlePagination}
            isZeroIndex={path === 'links'}
            defaultPage={path !== TransactionsType.paymentlinks && path !== TransactionsType.bulkrefund ? 1 : 0}
          />
          {path === 'campaigns' && (
            <SearchFilter label={'Search by Campaign Id'} onSearchPress={handleCampaignSearch} />
          )}
          <FieldSettingsFilterMenu
            hide={
              path !== TransactionsType.transactions &&
              path !== TransactionsType.paymentlinks &&
              path !== TransactionsType.subscriptions &&
              path !== 'campaigns' &&
              (path === 'tokenTransactions' || !showFieldSettingsAndFilters)
            }
            setFieldSettingVisible={setFieldSettingVisible}
            fieldSettingVisible={fieldSettingVisible}
            setFilterVisible={setFilterVisible}
            filterVisible={filterVisible}
            hideFieldSettings={hideFieldSettings}
            path={path}
            subscriptionFiltersCount={subscriptionFiltersCount}
            clearSubscriptionFilters={clearFilters}
            isFiltersApplied={isFiltersApplied}
            isTransactionFilterApplied={isTransactionFilterApplied}
            returnTransactionFilterCount={returnTransactionFilterCount}
            returnPaymentLinkFilterCount={returnPaymentLinkFilterCount}
            paymentLinkFilterApplied={paymentLinkFilterApplied}
            returnBeneficiaryFilterCount={returnBeneficiaryFilterCount}
          />
          <ModBox show={showExportOnRight} ml={16}>
            <DropdownOptimised
              testID="exportDropDown"
              placeHolder={actionMenuStrings.export}
              onChange={handleOnChange}
              data={dataExport}
              onButtonPress={onAction}
              type={dropDownType.exportModalType}
              hide={
                isMobile ||
                !(path !== TransactionsType.settlements) ||
                path === TransactionsType.paymentlinks ||
                path === TransactionsType.subscriptions ||
                path === TransactionsType.bulkrefund ||
                path === 'campaigns' ||
                path === 'reports' ||
                hideExportButton
              }
            />
          </ModBox>
          <Spacer size={10} direction="horizontal" hide={!enableRefundsAction} />
          <Spacer size={10} hide={!enableRefundsAction} />
          <Button
            testID="navigate"
            onPress={navigateTo}
            type={'SecondaryWithBg'}
            hide={!enableRefundsAction}
            title={actionMenuStrings.labelRefundCancel}
          />
        </Box>
      </Box>
      <ModBox show={fieldSettingVisible}>
        <FieldSettings
          path={path}
          setFieldSettingVisible={setFieldSettingVisible}
          fieldSettingVisible={fieldSettingVisible}
          applyFilters={applyFilters}
          fetchTxnColumns={fetchTxnColumnsData}
        />
      </ModBox>
      <ModBox show={filterVisible} >
        <Filters
          path={path}
          setFilterVisible={setFilterVisible}
          filterVisible={filterVisible}
          applyFilters={applyFilters}
        />
      </ModBox>
    </>
  )
}

export default observer(ActionsMenu)
